import React, { useState } from "react";
import "./MessageCodes.css";

const MessageA1i = (props) => {
  const [onClick , setOnClick] = useState(false)
  return (
    <div className="a1-wrap" style={{ width: "fit-content" }}>
      <div
        className={
          !onClick
            ? "chat-label action-tab action-button"
            : "chat-label-select action-tab"
        }
        id="main-tab1"
        style={{ color: props.disable && "grey" }}
        onClick={() => {
          if (!props.disable) {
            props.handleClick(props.item.code, null, props.item.text);
            props.setTextOnClick(props.item.text);
            setOnClick(true)
          }
        }}
      >
        {props.item.text}
      </div>
    </div>
  );
};

export default MessageA1i;